import styled from "styled-components";

export const FestivalRankItemWrapper = styled.div`
  background: #fff;
  width: 100%;
  height: 46px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 9px 12px;
  box-sizing: border-box;
  border-radius: 8px;
  color: #121212;

  > .point {
    font-weight: 700;
    font-size: 12px;
  }
`;

export const FestivalRankUserWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;

  > .rank {
    font-weight: 700;
    font-size: 14px;
    min-width: 30px;
  }
`;

export const FestivalRankUserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;

  > .nickname {
    font-weight: 700;
    font-size: 12px;
  }

  > .pub {
    font-weight: 500;
    font-size: 10px;
  }
`;
